(() => {
  if (window.wwProductSectionImages) {
    window.wwProductSectionImages.scan(document);
    return;
  }
  const sizeImage = (img) => {
    const width = Math.ceil(img.getBoundingClientRect().width);
    if (!width) return;
    const sizes = `${width}px`;
    img.sizes = sizes;
    img.closest('picture')?.querySelectorAll('source').forEach((source) => {
      source.sizes = sizes;
    });
  };
  const sizeObserver = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
    entries.forEach(({ target }) => sizeImage(target));
  }) : null;
  const hydrate = (img) => {
    img.loading = 'eager';
    img.fetchPriority = 'auto';
    const reveal = () => {
      img.classList.add('bls-loaded-image');
      img.closest('.bls-loading-image')?.classList.remove('bls-loading-image');
    };
    img.addEventListener('load', reveal, { once: true });
    sizeImage(img);
    sizeObserver?.observe(img);
    const picture = img.closest('picture');
    picture?.querySelectorAll('source[data-srcset]').forEach((source) => {
      source.srcset = source.dataset.srcset;
      source.removeAttribute('data-srcset');
    });
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    if (img.complete && img.naturalWidth > 0) reveal();
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-ww-product-image');
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        hydrate(target);
        observer.unobserve(target);
      }
    });
  }, { rootMargin: '2400px 0px' }) : null;
  const warmSlideshow = (slider) => {
    slider.querySelectorAll('picture img').forEach((img) => {
      img.loading = 'eager';
      img.fetchPriority = 'auto';
    });
  };
  const slideshowObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      warmSlideshow(target);
      slideshowObserver.unobserve(target);
    });
  }, { rootMargin: '2400px 0px' }) : null;
  const scan = (root) => {
    root.querySelectorAll('.bls__slideshow').forEach((slider) => {
      if (slideshowObserver && !window.Shopify?.designMode) slideshowObserver.observe(slider);
      else warmSlideshow(slider);
    });
    root.querySelectorAll('[data-ww-product-image]').forEach((img) => {
    if (observer && !window.Shopify?.designMode) observer.observe(img);
    else hydrate(img);
  });
  };
  window.wwProductSectionImages = { scan };
  scan(document);
  document.addEventListener('shopify:section:load', ({ target }) => scan(target));
})();


